module.exports = __webpack_public_path__ + "media/notif2.c3e5b168.wav";